import { deepClone } from "../../utils/global_functions";
import { WALKTHROUGH_POPOVER } from "../../utils/global_variables";
import { WALKTHROUGH } from '../actionTypes';


export const walkthroughPopoversContentUpdate = (pathName) => async (dispatch, getState) => {
    let payload = {};

    for (let i = 1; i <= WALKTHROUGH_POPOVER[pathName]; i++) {
        if (i === 1) {
            payload = { 1: true };
        } else {
            payload = { ...payload, [i]: false };
        }
    }

    if (Object.keys(payload).length) {
        dispatch(createWalkthroughPopoverObj(payload));
    }
};


export const toggleWalkThroughPopover = (curr, mod) => async (dispatch, getState) => {

    let payload = deepClone(getState().walkthroughPopovers);


    if (curr && mod) {
        payload = { ...payload, [curr]: false, [mod]: true };
        dispatch(createWalkthroughPopoverObj(payload));
    } else {
        dispatch(createWalkthroughPopoverObj({}));
    }

};



export const createWalkthroughPopoverObj = (payload) => {
    return { type: WALKTHROUGH.CREATE_WALKTHROUGH_POPOVER_OBJ, payload };
};